
/* injects from baggage-loader */

'use strict';

export default class BookmarksController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/bookmarks/bookmarks.controller.js